import Vue from 'vue';
import VueYouTubeEmbed from 'vue-youtube-embed';
import VueAnalytics from 'vue-analytics';
import App from './App.vue';
import router from './router';
import store from './store';

Vue.config.productionTip = false;

Vue.use(VueYouTubeEmbed);

Vue.use(VueAnalytics, {
  id: 'UA-115619454-2',
  router,
  autoTracking: {
    pageviewTemplate(route) {
      return {
        page: `/breitbard-mobile/${route.name}`,
        title: `Breitbard Mobile App`,
        location: `/breitbard-mobile/${route.path}`
      };
    }
  },
  debug: {
    enabled: false
  }
});

const requireComponent = require.context('./components', false, /\.(vue|js)$/);

requireComponent.keys().forEach(fileName => {
  const componentConfig = requireComponent(fileName);
  const componentName = fileName.replace(/^\.\/(.*)\.\w+$/, '$1');
  Vue.component(componentName, componentConfig.default || componentConfig);
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');

(function(i, s, o, g, r, a, m) {
  i['GoogleAnalyticsObject'] = r;
  (i[r] =
    i[r] ||
    function() {
      (i[r].q = i[r].q || []).push(arguments);
    }),
    (i[r].l = 1 * new Date());
  (a = s.createElement(o)), (m = s.getElementsByTagName(o)[0]);
  a.async = 1;
  a.src = 'https://www.google-analytics.com/analytics.js';
  m.parentNode.insertBefore(a, m);
})(window, document, 'script', '//www.google-analytics.com/analytics.js', 'ga');

var GA_LOCAL_STORAGE_KEY = 'ga:clientId' + Math.floor(Math.random() * 100000);

ga('create', 'UA-115619454-2', 'auto', {
  storage: 'none',
  clientId: localStorage.getItem(GA_LOCAL_STORAGE_KEY)
});

ga(function(tracker) {
  localStorage.setItem(GA_LOCAL_STORAGE_KEY, tracker.get('clientId'));
});

ga('set', 'checkProtocolTask', null);